import { render, staticRenderFns } from "./QuizGenericAnswerField.vue?vue&type=template&id=94fda88c&"
import script from "./QuizGenericAnswerField.vue?vue&type=script&lang=js&"
export * from "./QuizGenericAnswerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports